import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ForgotUserPassword } from "../../../Store/userSlice";
import logo from "../../../assets/images/logo.png";
import "./ForgotPass.css";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPass = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!emailPattern.test(email.trim())) {
      setError("Veuillez saisir une adresse e-mail valide.");
      return;
    }

    setLoading(true);
    try {
      const result = await dispatch(ForgotUserPassword(email.trim()));
      if (result.payload?.status === 200) {
        setSuccess(true);
        setEmail("");
      } else {
        const msg = result.payload?.data?.message;
        if (Array.isArray(msg)) {
          setError(msg[0]);
        } else {
          setError(msg || "Une erreur est survenue. Veuillez réessayer.");
        }
      }
    } catch {
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">

        <NavLink to="/">
          <img src={logo} alt="Casa del Padel" className="forgot-logo" />
        </NavLink>

        <h1 className="forgot-title">Mot de passe oublié ?</h1>
        <p className="forgot-subtitle">
          Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        {error && <div className="forgot-error">{error}</div>}
        {success && (
          <div className="forgot-success">
            Un e-mail de réinitialisation a été envoyé. Vérifiez votre boîte de réception.
          </div>
        )}

        {!success && (
          <form className="forgot-form" onSubmit={handleSubmit} noValidate>
            <div className="forgot-field">
              <label className="forgot-label" htmlFor="forgot-email">
                Adresse e-mail
              </label>
              <input
                id="forgot-email"
                type="email"
                className="forgot-input"
                placeholder="exemple@mail.com"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                autoComplete="email"
                autoCapitalize="none"
              />
            </div>

            <button type="submit" className="forgot-submit" disabled={loading}>
              {loading ? "Envoi en cours…" : "Envoyer le lien"}
            </button>
          </form>
        )}

        <p className="forgot-back-hint">
          <NavLink to="/login" className="forgot-back-link">
            ← Retour à la connexion
          </NavLink>
        </p>

      </div>
    </div>
  );
};

export default ForgotPass;
